import { authenticate, authentication } from '@/modules/authentication';
import { RawLocation, Route } from 'vue-router';

export async function authenticationGuard(to: Route, _from: Route, next: (to?: RawLocation) => void): Promise<void> {
  if (to.meta && to.meta.authorizedUserRoles) {
    let user = authentication.user;
    if (!user) {
      try {
        user = await authenticate();
      } catch {
        return next('/unauthorized');
      }
    }
    const userRoles = user.memberof.map(group => group.cn);
    const userIsAllowed = to.meta.authorizedUserRoles.some((role: string) => userRoles.includes(role));
    if (userIsAllowed) {
      return next();
    }

    return next('/forbidden');
  }

  return next();
}
